import { render, staticRenderFns } from "./vendors-integration-settings-page.vue?vue&type=template&id=37a9e00f&scoped=true&"
import script from "./vendors-integration-settings-page.vue?vue&type=script&lang=js&"
export * from "./vendors-integration-settings-page.vue?vue&type=script&lang=js&"
import style0 from "./vendors-integration-settings-page.vue?vue&type=style&index=0&id=37a9e00f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a9e00f",
  null
  
)

export default component.exports